//  CallFormView component, api end point accesing from apiConfig - 23-08-24 - Dev Srini

import  { useState, useContext, useEffect } from "react";

// srini - 18-06-25
import { httpRequest } from "../../../../ui-utils/api";
import snackError from "../../../../helpers/snackError";
import { reducerContext } from "../../../../contextApi's/contextApi's";
import { apiUrl, backendHosts } from "../../../../ui-utils/apiConfig";
import MainTabLayout from "./MainTabLayout/MainTabLayout";
import axios from "axios";

const Operations = () => {
  // srini - 18-06-25
  const { dispatch } = useContext(reducerContext)

  const [tabId, setTabId] = useState(1); // srini - 05/06/25
  const [nomineeList, setNomineeList] = useState([])
  const [fnoList, setFnoList] = useState([])
  const [acList,setAclist]=useState([])
  const [bankList, setBankList] = useState([]) // srini - 14/07/25
    const [userList, setUserList] = useState([])
  const [ddpilist,setDDPIList]=useState([])

  // useEffect(() => {
  //   const today = new Date();
  //   const threeMonthsAgo = new Date(today);
  //   threeMonthsAgo.setMonth(today.getMonth() - 3);
  //   threeMonthsAgo.setDate(1);



  //   const fdate = threeMonthsAgo.toISOString().split("T")[0];
  //   const tdate = today.toISOString().split("T")[0];

  //   const payload = { fdate, tdate };

  //   fetchFnoData(payload);
  // }, []);

  // const fetchFnoData = async (payload) => {
  //   try {
  //     const response = await httpRequest({
  //       endPoint: `${backendHosts.ADMIN}${apiUrl.getfnoList}`,
  //       method: "post",
  //       instance: "instanceOne",
  //       requestBody: payload,
  //     });

  //     // Filter for pending records
  //     const pendingRecords = response.filter(item => item.status === "Pending");
  //     setFnoList(pendingRecords)
  //     console.log("Pending Records:", pendingRecords);
  //     console.log("Total Pending Records:", pendingRecords.length);

  //   } catch (error) {
  //     console.log("Error in fno List API", error);
  //   }
  // };

  useEffect(() => {
    const today = new Date();
    const threeMonthsAgo = new Date(today);
    threeMonthsAgo.setMonth(today.getMonth() - 3);
    threeMonthsAgo.setDate(1);



    const fdate = threeMonthsAgo.toISOString().split("T")[0];
    const tdate = today.toISOString().split("T")[0];

    const formData = { fdate, tdate, src: "back_office" }
    const payload = { data: formData }

    fetchRequests(payload);
    fetchAccountClosureData(payload)
  }, []);
  const fetchRequests = async (payload) => {
    try {
      console.log("1", `${backendHosts.REG}${apiUrl.reqList}`)
      // const res = await axios.post(`${backendHosts.REG}${apiUrl.reqList}`, payload);
      const res = await axios.post(`${backendHosts.REG}/fno/request-list`, payload);
      console.log("2", res)
      // Filter for pending records
      const pendingRecords = res.data.data.data.filter(item => item.status === "Pending");
      setFnoList(pendingRecords)
      console.log("Pending Records:", pendingRecords);
      console.log("Total Pending Records:", pendingRecords.length);
    } catch (err) {
      console.error("Failed to fetch FNO list:", err);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const nomineeResult = await httpRequest({
          endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.nomineeQuery}`,
          method: "get",
          instance: "instanceTwo",
          params: {
            status: 'pending'
          }
        })

        if (nomineeResult.status === 200) {
          setNomineeList(nomineeResult.data)
        } else {
          dispatch({ type: 'SET_SHOW_ERROR', payload: true })
          dispatch({ type: 'SET_ERROR', payload: 'Error in fetching nominee List' })
          dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
          console.log("Error in fetching Engagement List", nomineeResult)
        }
      } catch (error) {
        dispatch({ type: 'SET_SHOW_ERROR', payload: true })
        dispatch({ type: 'SET_ERROR', payload: 'Error in fetching nominee List' })
        dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
        console.log("Error in fetching Engagement List", error)
      }
    })()
  }, [])

   useEffect(() => {
    (async () => {
      try {
        // const bankResult = await httpRequest({
        //   endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.filterBankVerifyRecords}`,
        //   method: "get",
        //   instance: "instanceTwo",
        //   params: {
        //     type: 'pending'
        //   }
        // })

        const bankResult = await axios.get(`${backendHosts.BACK_OFFICE}${apiUrl.addBankFetchLogs}?type=pending`)

        console.log("qaa", bankResult?.data?.status, bankResult?.data?.data.success, bankResult?.data?.data?.data)

        if (bankResult?.data?.status === 200 && bankResult?.data?.data.success) {
          setBankList(bankResult?.data?.data?.data)
        } else {
          dispatch({ type: 'SET_SHOW_ERROR', payload: true })
          dispatch({ type: 'SET_ERROR', payload: 'Error in fetching bank verification List' })
          dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
          console.log("Error in fetching bank verification List", bankResult)
        }
      } catch (error) {
        dispatch({ type: 'SET_SHOW_ERROR', payload: true })
        dispatch({ type: 'SET_ERROR', payload: 'Error in fetching bank verification List' })
        dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
        console.log("Error in fetching bank verification List", error)
      }
    })()
  }, [])

  //  useEffect(() => {
  //   const today = new Date();
  //   const threeMonthsAgo = new Date(today);
  //   threeMonthsAgo.setMonth(today.getMonth() - 3);
  //   threeMonthsAgo.setDate(1);

   

  //   const fdate = threeMonthsAgo.toISOString().split("T")[0];
  //   const tdate = today.toISOString().split("T")[0];

  //   const payload = { fdate, tdate };
  //   console.log('AccountClosure',payload)
  //     fetchAccountClosureData(payload);
    
  //   }
  // , []);

  // const fetchAccountClosureData = async (payload) => {
  //   try {
  //   //   const response = await axios.post(
  //   //     `http://localhost:5008/accountclosure/accountclosure-list`,
  //   //       payload // { fdate, tdate }
  //   //   );
  //    const response = await httpRequest({
  //       endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.acList}`,
  //       method: "post",
  //       instance: "instanceOne",
  //        requestBody: payload,
  //     });

  //     console.log('acList res',response)
  //     if (response) {
  //       const allData = response
  //       console.log("AccountClosureData",allData)
  //       const pendingRecords = allData.filter(item => item.stage === "signed");
  //       console.log('from operations',pendingRecords)
  //       setAclist(pendingRecords)

        
  //     } else {
  //       console.log("Error in LearningCentre List API", response.data);
  //     }
  //   } catch (error) {
  //     console.log("Error in LearningCentre List API", error);
  //   }
  // };

  //   useEffect(() => {
  //   const today = new Date();
  //   const threeMonthsAgo = new Date(today);
  //   threeMonthsAgo.setMonth(today.getMonth() - 3);
  //   threeMonthsAgo.setDate(1);

   

  //   const fdate = threeMonthsAgo.toISOString().split("T")[0];
  //   const tdate = today.toISOString().split("T")[0];

  //   const payload = { fdate, tdate };
  //   console.log('UE',payload)
  //     fetchAccountClosureData(payload);
    
  //   }
  // , []);
  
  const fetchAccountClosureData = async (payload) => {
    try {
      // const response = await axios.post(
      //   `http://localhost:5002/accountclosure/accountclosure-list`,
      //     payload // { fdate, tdate }
      // );
     const response = await httpRequest({
        endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.acList}`,
        method: "post",
        instance: "instanceOne",
         requestBody: payload,
      });

      console.log('res',response)
      if (response) {
        const allData = response
        console.log("AccountClosureData",allData)
        const pendingRecords = allData.filter(item => item.stage === "signed");
        console.log('from operations',pendingRecords)
        setAclist(pendingRecords)
      } else {
        console.log("Error in LearningCentre List API", response.data);
      }
    } catch (error) {
      console.log("Error in LearningCentre List API", error);
    }
  };


  const handleTabChange = (event, newValue) => {
    setTabId(newValue);
  };

  useEffect(() => {
    const today = new Date();
    const threeMonthsAgo = new Date(today);
    threeMonthsAgo.setMonth(today.getMonth() - 3);
    threeMonthsAgo.setDate(1);

    const fdate = threeMonthsAgo.toISOString().split("T")[0];
    const tdate = today.toISOString().split("T")[0];

    fetchDdpiData({ fdate, tdate });
  }, []);

  const fetchDdpiData = async (payload) => {
    try {
      const response = await httpRequest({
        endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.ddpiList}`,
        method: "post",
        instance: "instanceOne",
        requestBody: payload,
      });
      console.log("fetchDdpiData",response)
      if (response) {
        const allData = response?.ddpiRecords;
        const filtered = allData.filter((item) => item.stage === 'signed');
       setDDPIList(filtered)
      }
    } catch (error) {
      console.error("Error fetching DDPI data:", error);
    }
  };
    
  console.log(tabId);
  return (
    <div style={{ width: "87%", marginLeft: "2%",height:"100%"}}>
      <MainTabLayout tabId={tabId} handleTabChange={handleTabChange} nomineeList={nomineeList} fnoList={fnoList} acList={acList} userList={userList} bankList={bankList} ddpilist={ddpilist}/>
    </div>
  );
};

export default Operations;
